import { BUILD_VERSION_META_NAME, VERSION_ENDPOINT } from "./constants";

interface VersionResponse {
  frontendContractVersion?: number;
}

export interface BackendVersionResult {
  frontendContractVersion: number;
}

const getApiBase = (): string => (import.meta.env.VITE_APP_API_URL as string || "").replace(/\/+$/, "");

export const fetchBackendRequiredVersion = async (): Promise<BackendVersionResult | null> => {
  try {
    const res = await fetch(`${getApiBase()}${VERSION_ENDPOINT}`, { cache: "no-store" });
    if (!res.ok) return null;

    const data: VersionResponse = await res.json();
    if (typeof data?.frontendContractVersion !== "number") return null;

    return { frontendContractVersion: data.frontendContractVersion };
  } catch {
    return null;
  }
};

const BUILD_VERSION_META_REGEXP = new RegExp(
  `<meta\\s+name=["']${BUILD_VERSION_META_NAME}["']\\s+content=["']([^"']*)["']`,
  "i"
);

export const fetchFrontendBuildVersion = async (): Promise<string | null> => {
  try {
    const res = await fetch("/index.html", { cache: "no-store" });
    if (!res.ok) return null;

    const html = await res.text();
    const match = html.match(BUILD_VERSION_META_REGEXP);
    return match?.[1] || null;
  } catch {
    return null;
  }
};

export const getCurrentFrontendBuildVersion = (): string | null => {
  if (typeof document === "undefined") return null;
  return document.querySelector(`meta[name="${BUILD_VERSION_META_NAME}"]`)?.getAttribute("content") || null;
};
